import { Component, EventEmitter, Input, Output, inject, OnInit, signal } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ALERT_TYPE } from 'src/app/constants';
import { TsMonth } from 'src/app/month.util';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Business, BUSINESS_TYPE, createEmptyBusiness } from 'src/model/business';
import { BusinessService } from 'src/services/business.service';

@Component({
    selector: 'app-add-update-business',
    templateUrl: './add-update-business.component.html',
    styleUrl: './add-update-business.component.scss',
    standalone: false
})
export class AddUpdateBusinessComponent implements OnInit {
  protected activeModal = inject(NgbActiveModal);
  protected enums = inject(Enums);
  protected sharedService = inject(SharedService);
  private businessService = inject(BusinessService);

  readonly allMonths = Array.from({ length: 12 }, (_, i) => i as TsMonth);
  @Input() businessToUpdate: Business;
  @Input() isEdit = false;
  @Output() passEntry = new EventEmitter<any>();
  business = signal<Business>(createEmptyBusiness());

  BUSINESS_TYPE = BUSINESS_TYPE;
  minDate = new Date();

  ngOnInit(): void {
    this.resetBusiness();
  }

  resetBusiness() {
    if (this.isEdit) {
      this.business.set({ ...this.businessToUpdate });
    } else {
      this.business.set(createEmptyBusiness());
    }
  }

  async addOrUpdateBusiness() {
    let t: Business;
    let message = '';
    if (this.isEdit) {
      if (this.business().RequireConsentForm !== this.businessToUpdate.RequireConsentForm) {
        await this.businessService.putToggleConsentForm(this.business().Id);
      }
      t = await this.businessService.putUpdateBusiness(this.business());
      message = "Successfully updated business!";
    } else {
      t = await this.businessService.postAddBusiness(this.business());
      message = "Successfully added new business!";
    }
    this.passEntry.emit(t);
    this.activeModal.close();
    this.sharedService.openAlert(message, ALERT_TYPE.SUCCESS);
  }
}
